import { formatNumberExplicitly, makeSpacesNonBreakable } from '../helpers';
export function formatNumber(value, culture, decimals) {
  if (!culture) {
    // it is preferred by the business to display the value formatted in the runtime culture than no value at all
    return value.toLocaleString();
  }
  var NumberFormat = culture.NumberFormat;
  return makeSpacesNonBreakable(formatNumberExplicitly(value, decimals !== null && decimals !== void 0 ? decimals : NumberFormat.Decimals, NumberFormat.DecimalSeparator, NumberFormat.GroupSizes, NumberFormat.GroupSeparator, {
    negativePattern: NumberFormat.NegativePattern
  }));
}